<template>
  <BaseListContactsPage
    :tabs="tabs"
    :current-tab="currentTab"
    :contacts-selectable="!massTextIcon.disabled"
    :get-gql-query="getGqlQuery"
    :get-items="getItems"
    :get-total-items-count="getTotalItemsCount"
    :get-query-variables="getQueryVariables"
    :update-context-variable="updateContextVariable"
    :on-tab-changed="onTabChanged"
    :get-total-contacts="getTotalContacts"
  />
</template>

<script>
import BaseListContactsPage from '@/pages/BaseListContactsPage'
import { LIST_GROUP_CONTACTS_WITH_WORK } from '@/backend/graphql/groupGQL'
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'GroupContactsPage',
  components: { BaseListContactsPage },
  data: function () {
    return {
      currentTab: 'tab-1',
      getGqlQuery: LIST_GROUP_CONTACTS_WITH_WORK,
      limit: 50,
      offset: 0,
      orderBy: '-profile__id,-profile__last_recv_at',
      profileIsDelete: 0,
      window: {
        width: 0,
        height: 0
      },
      tabs: {
        'tab-1': this.$route.query.groupName
      }
    }
  },
  computed: {
    ...mapGetters({ massTextIcon: 'toolBar/getMassTextIcon' })
  },
  created () {
    // reactive query and variables
    this.groupId = this.$route.params.groupId
    this.setEditMenuItems({ val: [
      { title: 'Edit Contacts',
        route: { name: 'editGroupContacts',
          params: { groupId: this.groupId }
        } },
      { title: 'Add Contacts' },
      { title: 'Remove Contacts' }
    ] })
  },
  methods: {
    ...mapActions({ setEditMenuItems: 'toolBar/setEditMenuItems' }),
    getItems (data) {
      return data.listGroupProfile.results.map(obj => obj.profile)
    },
    getTotalItemsCount (data) {
      return data.listGroupProfile.totalCount
    },
    getQueryVariables () {
      return {
        limit: this.limit,
        offset: this.offset,
        orderBy: this.orderBy,
        groupId: this.groupId,
        profileIsDelete: this.profileIsDelete
      }
    },
    updateContextVariable (key, value) {
      if (this.hasOwnProperty(key)) {
        this[key] = value
      }
    },
    getTotalContacts (value) {
      if (value === this.currentTab) { return this.$store.getters['contact/getTotalCount'] } else { return '?' }
    },
    onTabChanged (value) {
      this.currentTab = value
    }
  }
}
</script>

<style scoped>

</style>
